<template>
    <div class="emp-card" :key="`emp-${employeeId}`">
        <DxDataGrid :data-source="dsCertificateMedicale" ref="dataGridRef" :allow-column-reordering="true"
            :allow-column-resizing="true" :column-auto-width="false" :show-borders="true" key-expr="Id">
            <DxSelection mode="single" />
            <DxFilterRow :visible="false" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxScrolling mode="standard" :show-scrollbar="'always'" />
            <DxColumnFixing :enabled="true" />
            <DxEditing :allow-updating="true" mode="popup" >
                <DxPopup :closeOnOutsideClick="true" :showCloseButton="true" :width="700" :height="450"
                    :show-title="false" >
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="saveButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
            </DxEditing>
            <DxColumn data-field="SickId" caption="Cauza" width="150" />
            <DxColumn data-field="Procent" width="140" />
            <DxColumn data-field="CnpCopil" width="140" caption="CNP Copil" />
            <DxColumn data-field="CodUrg" width="140" caption="Cod Urgenta"/>
            <DxColumn data-field="Diagnostic" width="140" />
            <DxColumn data-field="DataAcord" width="140" />
            <DxColumn data-field="FromDate" caption="De la" width="140" />
            <DxColumn data-field="ToDate" caption="Pana la" width="140" />
            <DxColumn data-field="LunaPlatii" width="140" />
            <DxColumn data-field="Serie" width="140" caption="Serie CM"/>
            <DxColumn data-field="Numar" width="140" caption="Numar CM"/>
            <DxColumn data-field="Continuare"  width="100" />
            <DxColumn data-field="SerieInitial" width="140" caption="Seria Initiala" />
            <DxColumn data-field="NumarInitial" width="140" />
            <DxColumn data-field="LocPres" width="140" caption="Loc PREST"/>
            <DxColumn data-field="MedicPrescriptor" width="140" />
            <DxColumn data-field="Unitate" width="140" />
            <DxColumn data-field="Aviz"  width="100" />
            <DxColumn data-field="MeNr" width="140" />
            <DxColumn data-field="CompanyDays" width="140" caption="Zile Companie"/>
            <DxColumn data-field="BC" width="140" />
            <DxColumn data-field="CompanySum" width="140" />
            <DxColumn data-field="Vechime" width="150" />
            <DxColumn data-field="CurSickDays" width="140" />
            <DxColumn data-field="UnpayedDays" width="140" />
            <DxColumn data-field="BassDays" width="140" />
            <DxColumn data-field="BassSum" width="140" />
            <DxColumn data-field="CodContag" width="140" />
            <DxColumn data-field="ZiBzCalc" width="140" />
            <DxColumn data-field="BazaCalc" width="140" />
            <DxColumn data-field="BazaCalcManual" width="140" />
            <DxColumn data-field="SickProc" width="140" />
           

            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
            </DxToolbar>
        </DxDataGrid>
        <DxPopupAdd :visible="addPopupVisible" :show-title="true" :height="450" :width="700">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <DxForm :col-count="2" :data-source="formData" label-alignment="center">
                <DxSimpleItem data-field="SickId" />
                <DxSimpleItem data-field="Procent" editor-type="dxNumberBox"/>
                <DxSimpleItem data-field="CnpCopil" />
                <DxSimpleItem data-field="CodUrg" />
                <DxSimpleItem data-field="Diagnostic"  />
                <DxSimpleItem data-field="DataAcord"  editor-type="dxDateBox" />
                <DxSimpleItem data-field="FromDate"  editor-type="dxDateBox" />
                <DxSimpleItem data-field="ToDate"   editor-type="dxDateBox" />
                <DxSimpleItem data-field="LunaPlatii"  editor-type="dxDateBox"  />
                <DxSimpleItem data-field="Serie" />
                <DxSimpleItem data-field="Numar" />
                <DxSimpleItem data-field="Continuare" editor-type="dxCheckBox"/>
                <DxSimpleItem data-field="SerieInitial" />
                <DxSimpleItem data-field="NumarInitial" />
                <DxSimpleItem data-field="LocPres" />
                <DxSimpleItem data-field="MedicPrescriptor" />
                <DxSimpleItem data-field="Unitate" />
                <DxSimpleItem data-field="Aviz" editor-type="dxCheckBox"/>
                <DxSimpleItem data-field="MeNr" />
                <DxSimpleItem data-field="CompanyDays" />
                <DxSimpleItem data-field="BC" editor-type="dxNumberBox"/>
                <DxSimpleItem data-field="CompanySum" editor-type="dxNumberBox"/>
                <DxSimpleItem data-field="Vechime" editor-type="dxNumberBox"/>
                <DxSimpleItem data-field="CurSickDays" />
                <DxSimpleItem data-field="UnpayedDays" />
                <DxSimpleItem data-field="BassDays" />
                <DxSimpleItem data-field="BassSum" editor-type="dxNumberBox"/>
                <DxSimpleItem data-field="CodContag" />
                <DxSimpleItem data-field="ZiBzCalc" />
                <DxSimpleItem data-field="BazaCalc" editor-type="dxNumberBox" />
                <DxSimpleItem data-field="BazaCalcManual" editor-type="dxCheckBox"/>
                <DxSimpleItem data-field="SickProc" editor-type="dxNumberBox"/>

            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="addButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem,
    DxItem as DxFormItem,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxSearchPanel,
    DxScrolling,
    DxColumnFixing
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import PER_Meserii from '@/services/PER/PER_Meserii';

export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem,
        DxScrolling,
        DxColumnFixing
    },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(id) {
                if (!id || !this.$refs.dataGridRef?.instance) return;
                const ds = this.$refs.dataGridRef.instance.getDataSource();
                ds.filter(["EmpId", "=", id]);
                ds.load();
            }
        }
    },
    data() {
        return {
            dsCertificateMedicale: {} as DataSource,
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            editPopupVisible: false,
            formData: {
                Id: null,
                EmpId: null,
                Vechime: null,
                Continuare: false,
                SickId: null,
                FromDate: '',
                ToDate: '',
                CurSickDays: null,
                UnpayedDays: null,
                CompanyDays: null,
                BassDays: null,
                BC: null,
                CompanySum: null,
                BassSum: null,
                Aviz: false,
                LunaPlatii: '',
                Serie: '',
                Numar: '',
                SerieInitial: '',
                NumarInitial: '',
                CodContag: '',
                CodUrg: '',
                CnpCopil: '',
                DataAcord: '',
                ZiBzCalc: null,
                LocPres: null,
                BazaCalc: null,
                MeNr: '',
                MedicPrescriptor: '',
                Unitate: '',
                Diagnostic: '',
                SickProc: null,
                Procent: null,
                BazaCalcManual: false,
                UserCreare: '',
                DataCreare: '',
                UserModificare: '',
                DataModificare: ''
            },
            addButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:880px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
            },
        }
    },

    mounted() {
        this.dsCertificateMedicale = new DataSource({
            store: new ODataStore({
                version: 4,
                url: AppSetting.API_Url_ResurseUmaneOdata + "PER_EmpSicknesses",
                key: "Id",
                fieldTypes: { Id: "Guid", EmpId: "Guid" },
                beforeSend: e => {
                    e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                }
            }),

            filter: ["EmpId", "=", this.employeeId]
        });
    },
    methods: {
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return;
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        onSaveAdd() {
            if (!this.newMeserie.name || this.newMeserie.name.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 2000)
                return
            }
            if (!this.newMeserie.code || this.newMeserie.code.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 2000)
                return
            }
            PER_Meserii.save(this.newMeserie).then((meserie) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newMeserie = {
                    name: '',
                    code: '',
                    Active: false,
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 2000);
            })
        },
        onCloseAdd() {
            this.addPopupVisible = false

        },
    },
})
</script>
<style>
.circle-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle {
    width: 12px;
    height: 12px;
}

.circle-true {
    background-color: #4caf50;
    color: white;
}

.circle-false {
    background-color: #e71010;
}
</style>